import { i18n } from "@src/i18n/i18n";
import { updateShowMachineStructureDropAreaDeactivationOverlay } from "@src/reducers/your-reducer";
import store from "@src/reducers/store";
import { reminderSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";

const TIME_OUT = 5000;

export const activateMachineStructureDropAreaOverlay = () => {
  store.dispatch(updateShowMachineStructureDropAreaDeactivationOverlay(true));
  reminderSnackbar(
    i18n(
      "modules.snackbarNotifications.clearFilterMachineStructureToDragAndDrop",
    ),
    TIME_OUT,
  );
};
